import { useForm } from 'react-hook-form'

import { yupResolver } from '@hookform/resolvers/yup'
import { TextInput } from '@ui/components/core/TextInput'
import { DynamicFormProps } from '@ui/interfaces'
import { SaveAndCancelButtons } from '@ui/pages/pipelinesWorkflow/components/DestinationForms/SaveAndCancelButtons'
import * as Yup from 'yup'

const schema = Yup.object({
  host: Yup.string().required('Host must be provided'),
  port: Yup.string().required('Port must be provided'),
  dsn: Yup.string().required('Uptrace DSN is required'),
}).required()

export default function Uptrace(props: DynamicFormProps) {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      ...props.config,
    },
  })

  const { saveClick, cancelClick } = props

  return (
    <form onSubmit={handleSubmit(saveClick)}>
      {props.additionalInputs}
      <div>
        <TextInput
          label="Host*"
          placeholder="otlp.uptrace.dev"
          disabled={props.disableInputs}
          register={register}
          name="host"
          error={errors['host']?.message}
        />
        <TextInput
          label="Port*"
          placeholder="4317"
          disabled={props.disableInputs}
          register={register}
          name="port"
          error={errors['port']?.message}
        />
        <TextInput
          label="Uptrace DSN*"
          placeholder="https://token@api.uptrace.dev/project_id"
          disabled={props.disableInputs}
          register={register}
          name="dsn"
          error={errors['dsn']?.message}
        />
        {props.submitButton ? props.submitButton : <SaveAndCancelButtons cancelClick={cancelClick} />}
      </div>
    </form>
  )
}
